/**
 * Check if an API response indicates unauthorized access.
 *
 * Unauthorized codes:
 * - 10002: General unauthorized
 * - 40101: Token expired or invalid
 * - 401: HTTP 401 Unauthorized
 *
 * @param code - API response code
 * @param status - HTTP status code (optional)
 * @returns true if the response indicates unauthorized access
 *
 * @example
 * ```ts
 * if (isUnauthorized(response.code, response.status)) {
 *   // Handle unauthorized
 * }
 * ```
 */
export function isUnauthorized(
  code: string | number | undefined,
  status?: number,
): boolean {
  if (code === undefined && status === undefined) {
    return false;
  }

  const numericCode = Number(code);

  // Check for unauthorized codes
  return numericCode === 10002 || numericCode === 40101 || status === 401;
}
